
import * as PropTypes from 'prop-types';
import logo from '../assets/logo_footer.png';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { AccessToken } from '../config/AccessToken';
import { InteractionRequiredAuthError } from '@azure/msal-browser';


export const Footer = () => {
    const languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();
    const [imageLogo, setImageLogo] = useState<string | null>(null);

    const getImageLogo = async () => {

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/account/logo`, { headers })
            .then((res) => {
                const base64Image = res?.data?.data?.image;
                if (base64Image) {
                    setImageLogo(`data:image/png;base64, ${base64Image}`);
                }
            }).catch(() => {
                
            });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    useEffect(() => {
        getImageLogo();
    }, [])

    return (
        <div className="footer shell-footer">
            <div className="title shell-footer-title">
                {imageLogo ? (
                    <img
                        src={imageLogo}
                        alt="tenant"
                        className="shell-footer-logo shell-footer-logo--tenant"
                    />
                ) : null}
                <img
                    src={logo}
                    alt="locator"
                    className="shell-footer-logo shell-footer-logo--brand"
                />
            </div>
        </div>
    );
}

Footer.displayName = 'Footer';
Footer.propTypes = {
    page: PropTypes.string,
    onButtonClick: PropTypes.func,
    changeTheme: PropTypes.func,
    theme: PropTypes.string,
};
